<ng-container [formGroup]="linkFormSection">
  <div class="mt-3 flex-col">
    @for (flow of flows.controls; track flow; let i = $index) {
      <div
        class="border border-[#74808B] rounded-[8px] mx-[21px] px-[14px] py-[8px] text-[#424D57] mb-[8px]"
        >
        <div class="text-[16px] text-[#000] flex justify-between">
          First Part
          <button aria-label="Remove Conditional" (click)="removeConditional(i)" class="hover:bg-gray-200 rounded-full w-[24px] h-[24px]">
            <fa-icon [icon]="faXmark" />
          </button>
        </div>
        <div [formGroup]="flowGroup(i)">
          <div class="mb-[21px] text-[12px] text-[#8B96A2]">
            First add the part of the exam that the student will be evaluated from.
            <select
              formControlName="exampart_previous"
              class="flex mt-2 rounded-md p-2 text-gray-900 ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6"
            >
              <option value="null" disabled selected>Select a part</option>
              @for (part of parts.controls; track part; let x = $index) {
                @if (part.get('exampart_id')?.value == null) {
                  <option [value]="x * -1">
                    {{part.get('part_name')?.value}}
                  </option>
                } @else {
                  <option [value]="part.get('exampart_id')?.value">
                    {{part.get('part_name')?.value}}
                  </option>
                }
              }
            </select>
          </div>
          <div class="text-[16px] text-[#000]">
            Conditional Part
          </div>
          <div class="mb-[21px] text-[12px] text-[#8B96A2]">
            Second add the part of the exam  that the student will flow to from the previous part
            <select
              formControlName="exampart_next"
              class="flex mt-2 rounded-md p-2 text-gray-900 ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6"
              >
              <option value="null" disabled selected>Select a part</option>
              @for (part of parts.controls; track part; let x = $index) {
                @if (part.get('exampart_id')?.value == null) {
                  <option [value]="x * -1">
                    {{part.get('part_name')?.value}}
                  </option>
                } @else {
                  <option [value]="part.get('exampart_id')?.value">
                    {{part.get('part_name')?.value}}
                  </option>
                }
              }
            </select>
          </div>
          <div class="mt-[32px]">
            <div class="text-[16px]">
              Required Minimum Score
            </div>
            <div class="mb-[8px] text-[12px] text-[#8B96A2]">
              Minimum score that the student must receive in the <b>first part</b> to be able to <b>access</b> the <b>conditional part</b>
            </div>
            <div class="flex mb-[8px] items-center">
              @if (!flow.get('flow_noMin')?.value; as boolean) {
                <button (click)="noMinClick(flow)" class="bg-[#F6F7F8] rounded-[4px] text-[14px] px-[10px] py-[8px]">
                  None
                </button>
              }
              @if (flow.get('flow_noMin')?.value; as boolean) {
                <button (click)="noMinClick(flow)" class="text-white bg-[#74808B] rounded-[4px] text-[14px] px-[10px] py-[8px]">
                  None
                </button>
              }
              <div class="border border-[#D9D9D9] rounded h-[34px] w-[1px] mx-[8px]"></div>
              @if (!flow.get('flow_noMin')?.value) {
                <input formControlName="req_partscore_min" type="number" placeholder="Enter Value" class="disabled:bg-[#CBD1D7] disabled:text-[#8B96A2] bg-[#F6F7F8] rounded-[4px] px-[10px] py-[8px] noOutlineInput" />
              }
              @if (flow.get('flow_noMin')?.value) {
                <input [disabled]="true" type="number" placeholder="Enter Value" class="disabled:bg-[#CBD1D7] disabled:text-[#8B96A2] bg-[#F6F7F8] rounded-[4px] px-[10px] py-[8px] noOutlineInput" />
              }
              <div class="text-[#34393E] text-[14px] ml-[8px]">
                Min Score
              </div>
            </div>
            <div class="text-[16px] mt-[8px]">
              Required Maximum Score
            </div>
            <div class="mb-[8px] text-[12px] text-[#8B96A2]">
              Maximum score that the student must receive in the <b>first part</b> to be able to <b>skip</b> the <b>conditional part</b>
            </div>
            <div class="flex mb-[8px] items-center">
              @if (!flow.get('flow_noMax')?.value; as boolean) {
                <button (click)="noMaxClick(flow)" class="bg-[#F6F7F8] rounded-[4px] text-[14px] px-[10px] py-[8px]">
                  None
                </button>
              }
              @if (flow.get('flow_noMax')?.value; as boolean) {
                <button (click)="noMaxClick(flow)" class="text-white bg-[#74808B] rounded-[4px] text-[14px] px-[10px] py-[8px]">
                  None
                </button>
              }
              <div class="border border-[#D9D9D9] rounded h-[34px] w-[1px] mx-[8px]"></div>
              @if (!flow.get('flow_noMax')?.value) {
                <input formControlName="req_partscore_max" type="number" placeholder="Enter Value" class="disabled:bg-[#CBD1D7] disabled:text-[#8B96A2] bg-[#F6F7F8] rounded-[4px] px-[10px] py-[8px] noOutlineInput" />
              }
              @if (flow.get('flow_noMax')?.value) {
                <input [disabled]="true" type="number" placeholder="Enter Value" class="disabled:bg-[#CBD1D7] disabled:text-[#8B96A2] bg-[#F6F7F8] rounded-[4px] px-[10px] py-[8px] noOutlineInput" />
              }
              <div class="text-[#34393E] text-[14px] ml-[8px]">
                Max Score
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="flex justify-center mt-5">
      <outline-button text="Create Conditional" [faIcon]="faAdd" (click)="addConditional()" />
    </div>
  </div>
</ng-container>
